// Контент для страниц «Главная» и «Философия»

// Карточки философии (секция 3 на главной)
export const PHILOSOPHY_CARDS = [
  {
    id: 1,
    icon: 'shield',
    title: 'Предотвращать, а не лечить',
    description:
      'Большинство хронических заболеваний не появляются внезапно. Они формируются годами. Когда появляются симптомы — вы уже лечите следствия. В 90% случаев причины можно было устранить гораздо раньше — без сложных диет, бесконечных анализов и лечения. Именно этим мы и занимаемся.',
  },
  {
    id: 2,
    icon: 'data',
    title: 'Данные о вашем теле',
    description:
      'Регулярные анализы, биомаркеры и современные методы диагностики дают полную картину здоровья. Только объективные данные позволяют принимать обоснованные решения.',
  },
  {
    id: 3,
    icon: 'person',
    title: 'Персональный подход',
    description:
      'Нет единого рецепта здоровья для всех. Каждый человек уникален — мы поможем вам создать индивидуальные протоколы на основе ваших анализов, генетики и образа жизни.',
  },
  {
    id: 4,
    icon: 'science',
    title: 'Научная основа',
    description:
      'Все рекомендации основаны на актуальных клинических исследованиях и доказательной медицине. Мы следим за последними открытиями в области здоровья и долголетия.',
  },
];

// Шаги инновационного подхода (секция 4 на главной)
export const INNOVATION_STEPS = [
  {
    number: '01',
    title: 'Сообщество и доступ',
    description:
      'Вы получаете единомышленников, личное общение с Романом Терушкиным, закрытую информацию и доступ к закрытым чатам клуба.',
  },
  {
    number: '02',
    title: 'Регулярный контент',
    description:
      'Мы выпускаем 2\u20133 закрытых видео и онлайн-трансляции в месяц, не считая коротких кружков в чатах.',
  },
  {
    number: '03',
    title: 'Ответы на вопросы',
    description:
      'Задавайте вопросы в любое время — на них ответят специалисты или одноклубники. Самые интересные и горячие вопросы возьмёт на разбор сам Роман.',
  },
];

// Преимущества членства в клубе
export const CLUB_BENEFITS = [
  'Доступ к закрытым лекциям (2 в месяц) и вебинарам с ведущими врачами',
  '2 раза в месяц ответы на ваши вопросы от Терушкина Р.А.',
  'Персональные консультации со специалистами клуба (оплачиваются отдельно)',
  'Программы управления здоровьем на основе ваших данных',
  'Закрытое сообщество единомышленников, заботящихся о своём здоровье',
  'Поддержка и челленджи от таких же увлечённых здоровьем участников клуба',
  'Дополнительные скидки на лабораторные анализы и диагностику, а также специальные партнёрские предложения, которых нет нигде',
  'Ежемесячные отчёты о состоянии вашего здоровья и прогрессе',
];

// Популярные видео Романа Терушкина (страница «Философия»)
export const POPULAR_VIDEOS = [
  {
    id: 1,
    title: 'Почему вы устаёте: скрытые причины хронической усталости',
    duration: '1:08:55',
    url: 'https://www.youtube.com/watch?v=P4ymKRUYoB8',
    thumbnail: 'https://img.youtube.com/vi/P4ymKRUYoB8/maxresdefault.jpg',
  },
  {
    id: 2,
    title: 'Гормоны и вес: что на самом деле мешает похудеть',
    duration: '1:31:45',
    url: 'https://www.youtube.com/watch?v=zUj46YmBrYs',
    thumbnail: 'https://img.youtube.com/vi/zUj46YmBrYs/maxresdefault.jpg',
  },
  {
    id: 3,
    title: 'Сон и восстановление: как спать, чтобы жить дольше',
    duration: '1:23:15',
    url: 'https://www.youtube.com/watch?v=KhdHqDz0JqA',
    thumbnail: 'https://img.youtube.com/vi/KhdHqDz0JqA/maxresdefault.jpg',
  },
  {
    id: 4,
    title: 'Анализы, которые стоит сдавать каждому после 30',
    duration: '1:39:30',
    url: 'https://www.youtube.com/watch?v=6zCXCMY_0Xo',
    thumbnail: 'https://img.youtube.com/vi/6zCXCMY_0Xo/maxresdefault.jpg',
  },
];

// Расширенный контент для страницы «Философия»
export const PHILOSOPHY_SECTIONS = [
  {
    id: 1,
    title: 'Что такое превентивная медицина?',
    content:
      'Превентивная медицина — это подход, при котором главная задача врача не лечить болезнь, а предотвратить её появление. Вместо того чтобы ждать симптомов, мы систематически отслеживаем ваши биомаркеры, выявляем скрытые риски и устраняем их задолго до того, как они станут проблемой.',
  },
  {
    id: 2,
    title: 'Почему классической медицины недостаточно?',
    content:
      'Традиционная система здравоохранения ориентирована на лечение уже возникших заболеваний. Врач видит пациента, когда болезнь уже развилась. Наш подход иной: мы работаем с вашим здоровьем постоянно, не дожидаясь момента, когда что-то пойдёт не так.',
  },
  {
    id: 3,
    title: 'Долголетие — это управляемый процесс',
    content:
      'Современная наука убедительно показывает: продолжительность здоровой жизни во многом определяется не генетикой, а образом жизни и своевременными вмешательствами. Мы используем лучшие практики из области геронтологии (науки о старении), функциональной медицины и нутригеномики (науки о влиянии питания на активность работы наших генов), чтобы помочь вам жить дольше и лучше.',
  },
  {
    id: 4,
    title: 'Наши принципы работы',
    content:
      'Мы убеждены, что каждый человек заслуживает индивидуального внимания. Мы не даём обобщённых советов — мы анализируем конкретные данные конкретного человека и создаём персональную стратегию здоровья. Всё, что мы рекомендуем, основано на доказательной медицине.',
  },
  {
    id: 5,
    title: 'Что даёт превентивная медицина?',
    content:
      'Раннее выявление рисков позволяет избежать серьёзных заболеваний или значительно замедлить их развитие. Вы получаете контроль над ключевыми показателями здоровья: гормональным балансом, метаболизмом, качеством сна и уровнем энергии. Результат — не просто отсутствие болезней, а ощутимое улучшение самочувствия, работоспособности и качества жизни на годы вперёд.',
  },
];
